/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { User } from "../models/user";
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../services/user.service";
import { PagedResults } from "app/models/paged-results";
import { NUMBER_OF_USERS_PER_PAGE } from "app/components/users/user.component";

@Injectable()
export class UsersPagingResolver implements Resolve<PagedResults<User>> {

  constructor(
    private userService: UserService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<User>> {
    try {
      return await this.userService.getAllUsersForPaging(0, NUMBER_OF_USERS_PER_PAGE, 'ASC', "");
    } catch (error) {
      console.error("Problem resolving Rules... Error: " + error, error);
    }
  }

}
